import { useContext, useMemo } from "react";
import dataApplicationsContext, { FILTER_VALUES } from "../context/dataApplicationsContext";


const FilterRows = ({ displayUsers }) => {
  const { filterOnglet, setFilterOnglet } = useContext(dataApplicationsContext);

  const onglets = [
    { label: 'Toutes les lignes', key: 'all', value: FILTER_VALUES['all'] },
    { label: 'Afficher les Impayés', key: 'unpaids', value: FILTER_VALUES['unpaids'] },
    { label: 'Profils incomplets', key: 'partials', value: FILTER_VALUES['partials'] },
    { label: 'A rembourser', key: 'refunds', value: FILTER_VALUES['refunds'] },
    { label: 'A vérifier', key: 'reviews', value: FILTER_VALUES['reviews'] },
  ]

  const handleClick = (onglet) => {
    setFilterOnglet(onglet.value)
  }

  const getFraternityFinalRemaining = (user, list) => {
    if (!user.id_fraternity) return user.remaining_amount;
    const firstIndex = list.findIndex(u => u.id_fraternity === user.id_fraternity);
    const firstUser = list[firstIndex];
    let total = 0;
    for (let i = firstIndex; i < list.length; i++) {
      if (list[i].id_fraternity === user.id_fraternity) {
        total += list[i].remaining_amount;
      } else {
        break;
      }
    }
    return total - parseInt(firstUser.discount_fratrie, 10);
  };

  const kpis = useMemo(() => {
    if (!displayUsers) return null;
    return displayUsers.reduce(
      (acc, row) => {
        acc.all += 1;
        const finalRemaining = getFraternityFinalRemaining(row, displayUsers);
        if (finalRemaining > 0) acc.unpaids += 1;
        if (row.gender === 'NC') acc.partials += 1;
        if (row.needs_review) acc.reviews += 1;
        if (finalRemaining < 0) acc.refunds += 1;
        return acc;
      },
      { all: 0, unpaids: 0, partials: 0, refunds: 0, reviews: 0 }
    );
  }, [displayUsers]);


  const getCount = (key) => {
    return kpis?.[key] ?? 0;
  };

  return (
    <div className="onglet-filter-container">
      {onglets.map(onglet => {
        const active = filterOnglet === onglet.value ? 'active' : '';
        return (
          <p key={onglet.value} className={`onglet-row ${active}`} onClick={() => handleClick(onglet)}>
            {onglet.label}<span className="onglet-count">{getCount(onglet.key)}</span>
          </p>
        )
      })}
    </div>
  )
}

export default FilterRows